import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from '../../../../projects/accounting/src/lib/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ManageGuard implements CanActivate {
  constructor(
      private api: ApiService,
      private router: Router
      ){

  }

  canActivate(): boolean {
    if (!this.api.isManager()) {
      this.router.navigate(['/debts/outlets']);
      return false;
    }

    return true;
  }
}
